// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
}
.maintenance-page__content {
  max-width: 600px;
  text-align: center;
  width: 100%;
}
.maintenance-page__title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #000000;
}
.maintenance-page__text {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
  color: #000000;
}
.maintenance-page__email {
  color: #0066cc;
  text-decoration: none;
}
.maintenance-page__email:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/maintenancePage/MaintenancePage.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AACE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AACJ;AACE;EACE,cAAA;EACA,qBAAA;AACJ;AACI;EACE,0BAAA;AACN","sourcesContent":[".maintenance-page\n  display: flex\n  justify-content: center\n  align-items: center\n  min-height: 100vh\n  width: 100%\n  background-color: #ffffff\n  padding: 20px\n\n  &__content\n    max-width: 600px\n    text-align: center\n    width: 100%\n\n  &__title\n    font-size: 24px\n    font-weight: bold\n    margin-bottom: 20px\n    color: #000000\n\n  &__text\n    font-size: 16px\n    line-height: 1.6\n    margin-bottom: 16px\n    color: #000000\n\n  &__email\n    color: #0066cc\n    text-decoration: none\n\n    &:hover\n      text-decoration: underline\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
